module.exports = __webpack_public_path__ + "static/media/high_tide_small.4ac07fd4.jpg";